import React, { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function App({ dataSource }) {
  var themeColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-theme")
    .trim();
  var inverse = getComputedStyle(document.body)
    .getPropertyValue("--bs-inverse")
    .trim();
  var bodyBg = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-bg")
    .trim();

  const options = {
    responsive: true,
    scales: {
      x: {
        ticks: {
          color: "#d7d7d7",
        },
        grid: {
          color: "#4b4b4b",
        },
      },
      y: {
        ticks: {
          color: "#d5d5d5",
        },
        grid: {
          color: "#4b4b4b",
        },
      },
    },
    plugins: {
      tooltip: {
        bodyColor: "#1e2936",
        backgroundColor: "#1e2936",
        callbacks: {
          labelTextColor: function (context) {
            return "#f8f8f8";
          },
        },
      },
      legend: {
        position: "bottom",
      },
    },
  };
  const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true)
  // labels will be the date of data source if it exist only one date in the label
  useEffect(() => {
      if (dataSource && dataSource.length) {
      const labels = [];
      dataSource.created.map((item) => {
        // if not exist in the labels array
        if (!labels.includes(item.day)) labels.push(item.day);
      });
      dataSource.completed.map((item) => {
        // if not exist in the labels array
        if (!labels.includes(item.day)) labels.push(item.day);
      });
      const datasets = [];
      const created = dataSource.created.map((item, index) => {
        // check if day exist in the labels array
        const dayIndex = labels.indexOf(item.day);
        if (dayIndex !== -1) {
          return item.count;
        } else {
          return 0;
        }
      });
      const completed = dataSource.completed.map((item, index) => {
        // check if day exist in the labels array
        const dayIndex = labels.indexOf(item.day);
        if (dayIndex !== -1) {
          return item.count;
        } else {
          return 0;
        }
      });
      datasets.push({
        label: "Created",
        data: created,
        borderColor: themeColor,
        pointHoverColor: themeColor,
        backgroundColor: themeColor,
        pointBackgroundColor: bodyBg,
      });
      datasets.push({
        label: "Completed",
        data: completed,
        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      });
      // [
      //   {
      //     label: "Dataset 1",
      //     data: [1, 2, 3, 4, 5, 6, 7],

      //   },
      //   {
      //     label: "Dataset 2",
      //     data: [2, 3, 3, 4, 5, 6, 7],

      //   },
      // ],
      const data = {
        labels,
        datasets: datasets,
      };
      setData(data);
    }else {
        setData(null);
    }
      setLoading(false)
  }, [dataSource]);

  return !loading ? (
    <div style={{ position: "relative", height: "250px", width: "100%" }}>
        {data ? <Line options={options} data={data} />: null}
    </div>
  ) : (
    <div>
      <div className="spinner-grow text-primary"></div>
    </div>
  );
}
export default App;
